import { GET_COMMON } from '../types';

export default function common(state = {}, action) {
	switch (action.type) {
		case GET_COMMON:
			return action.payload;
		default:
			return state;
	}
}
